import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import AdminPage from "@/pages/AdminPage";
import CancelPage from "@/pages/CancelPage";
import RescheduleLookupPage from "@/pages/RescheduleLookupPage";

function App() {
  return (
    <div className="App min-h-screen bg-zinc-950">
      <div className="noise-overlay" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/reschedule" element={<RescheduleLookupPage />} />
          <Route path="/reschedule/:token" element={<CancelPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster 
        theme="dark" 
        position="top-center"
        toastOptions={{
          style: {
            background: '#18181b',
            border: '1px solid #27272a',
            color: '#fafafa',
          },
        }}
      />
    </div>
  );
}

export default App;
